<script setup lang="ts">
// defineEmits<{
//   // (event: 'update:modelValue', payload: string): void
// }>()

const model = defineModel<string | number | FileList | null | undefined>();
</script>

<template>
  <q-input
    v-model="model"
    filled
    no-error-icon
  />
</template>
